import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '='
    },
    template: `
        <ul class="courses">
            <li ng-repeat="item in vm.list.items" class="course hasactions">
                <div class="inner">
                    <div class="img">
                        <a ui-sref="authorized.courses.courses.edit.general({ id: item.id })">
                            <span>{{ 'course.Show course' | translate }}</span>
                            <img ng-if="item.imageFilename" ng-src="{{ vm.CourseService.getImageUrl(item, gridView) }}" alt="{{ item.activeI18n.name }}">
                            <img ng-if="!item.imageFilename" ng-src="assets/css/img01.png" alt="{{ item.activeI18n.name }}">
                        </a>
                    </div>
                    <div class="text">
                            <h2 ng-if="vm.TokenService.isCompanyMagnum()">
                                <a ui-sref="authorized.courses.courses.edit.general({ id: item.id })"
                                   title="{{ item.activeI18n.name }}" rel="bookmark">
                                    {{ item.sop }} {{ item.activeI18n.name }}
                                </a>
                            </h2>
                            <h2 ng-if="!vm.TokenService.isCompanyMagnum()">
                                <a ui-sref="authorized.courses.courses.edit.general({ id: item.id })" ui-sref-opts="{ location: 'replace' }"
                                   title="{{ item.activeI18n.name }}" rel="bookmark">
                                    {{ item.activeI18n.name }}
                                </a>
                            </h2>
                            <!-- use ng-bind for &nbsp; and other characters to be rendered correctly -->
                        <p ng-bind-html="vm.showDescription(item.activeI18n.description)"></p>
                        <ul class="actions01">
                            <li>
                                <a ui-sref="authorized.courses.courses.edit.general({ id: item.id })" class="btn edit">
                                    <span ng-if="vm.canManageCourses">{{ 'general.Edit' | translate }}</span>
                                    <span ng-if="!vm.canManageCourses">{{ 'general.View' | translate }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ul>
        <pagination list="vm.list"></pagination>
    `
})
export default class {
    constructor (PrivilegeService, TokenService, CourseService) {
        this.canManageCourses = PrivilegeService.canManageCourses();
        this.TokenService = TokenService;
        this.CourseService = CourseService;
    }

    showDescription (string) {
        if (!string) {
            return '';
        }
        // equivalent of strip tags in php
        const strippedString = string.replace(/(<([^>]+)>)/ig, '');

        return strippedString.length > 128 ? `${strippedString.substring(0, 128)}...` : strippedString;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/list/grid/index.js